/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.getFlashVoteHandler = () => $('[data-js-get-fv]').on('click', function(e) {
  e.preventDefault();
  const contactType = $(this).data('js-get-fv');
  const govType = contactType === 'gov';
  const citizenType = contactType === 'citizen';
  $('.gov-request').toggle(govType);
  return $('.citizen-request').toggle(citizenType);
});

/*
$(() => getFlashVoteHandler());
*/

function initFlashVoteHandlerOnLoad() {
  if ($('[data-js-get-fv]').length) {
    getFlashVoteHandler();
  }
}

$(initFlashVoteHandlerOnLoad);
document.addEventListener('turbo:load', initFlashVoteHandlerOnLoad);

